// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"Clock_buttonsContainer__Ooaz7","clock":"Clock_clock__2V9DX","watch":"Clock_watch__6pJVi","more":"Clock_more__3Xikl"};